/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Indicator threshold statuses
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type IndicatorThresholdStatusEnum = 'Poor' | 'Fair' | 'Good' | 'Very Good';

export const IndicatorThresholdStatusEnum = {
    Poor: 'Poor' as IndicatorThresholdStatusEnum,
    Fair: 'Fair' as IndicatorThresholdStatusEnum,
    Good: 'Good' as IndicatorThresholdStatusEnum,
    VeryGood: 'Very Good' as IndicatorThresholdStatusEnum
};

marker('Poor');
marker('Fair');
marker('Good');
marker('Very Good');

